var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88546 3.88564C5.87877 4.89232 4.26746 4.92588 3.22047 3.98631L3.11422 3.88564L0.528434 1.13934C0.268084 0.878995 0.268084 0.456885 0.528434 0.196535C0.768756 -0.0437871 1.14691 -0.0622736 1.40844 0.141076L1.47124 0.196535L4.05703 2.94283C4.55032 3.43612 5.33398 3.46209 5.85784 3.02072L5.94265 2.94283L8.52843 0.196536C8.78878 -0.0638142 9.21089 -0.0638142 9.47124 0.196536C9.71156 0.436858 9.73005 0.815012 9.5267 1.07654L9.47124 1.13934L6.88546 3.88564Z",
    fill: "#6C727F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.140a828b944763c10d0e31761ee7fbad.svg";
export { ForwardRef as ReactComponent };